/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["input[type=file][_ngcontent-%COMP%]{display:none}.upload_label[_ngcontent-%COMP%]{display:inline-block;cursor:pointer}.btn-import[_ngcontent-%COMP%]{vertical-align:middle;width:auto;color:#12408b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:5px;margin-right:5px;max-width:79px;font-size:13px;font-weight:400}.image-import[_ngcontent-%COMP%]{width:20px;height:20px}"];
export { styles as styles };

